module.exports = __webpack_public_path__ + "static/media/closeIcon.ffc7b600.svg";